import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import YodaDropdown from 'yoda-site-components/lib/components/YodaDropdown/YodaDropdown';
import Icon from 'yoda-core-components/lib/components/Icon';
import YdtSort from 'yoda-core-components/lib/assets/svg/YdtSort.svg';
import { updateUrl } from '../../utils';
import * as styles from './SortBy.css';

const cx = classNames.bind(styles);

/* istanbul ignore next */
const SortBy = ({ className }) => {
    const {
        context: {
            deviceType: { isDesktop = true, isTablet = false } = {},
            featureFlags: {
                enableDesktopViewForTabletLandscapeOrientation: enableDesktopViewForTablet = false,
            } = {},
        } = {},
        sortOptions: { sortOptions = [] } = {},
    } = useSelector((store) => store);

    const matchMediaQuery = () =>
        !__SERVER__ && isTablet && window.innerWidth && window.innerWidth >= 1024;

    const [isOrientationChange, setOrientation] = useState(matchMediaQuery());

    const onChange = (event) => {
        updateUrl(event, null, null, {});
    };

    const parseSortOptions = sortOptions.map(({ apiUrl: value = '', name: displayKey = '' }) => ({
        displayKey,
        value,
    }));

    const selectSortValue = () => {
        let defaultValue = null;
        const minWidth1024 = isOrientationChange;

        /* istanbul ignore next */
        if (sortOptions) {
            for (let i = 0; i < sortOptions.length; i += 1) {
                if (sortOptions[i].selected === true) {
                    defaultValue = sortOptions[i].apiUrl;

                    if (isDesktop || (isTablet && minWidth1024)) defaultValue = sortOptions[i].name;

                    break;
                }
            }
        }

        return defaultValue;
    };

    const handleOrientationChange = () => {
        const setOriention =
            (window.orientation && Math.abs(window.orientation) === 90) ||
            (window.screen && window.screen.width >= 1024);
        setOrientation(setOriention);
    };

    useEffect(() => {
        if (!__SERVER__ && isTablet) {
            window.addEventListener('orientationchange', () => handleOrientationChange());
            return () =>
                window.removeEventListener('orientationchange', () => handleOrientationChange());
        }
        return undefined;
    }, []);

    const labelClasses = cx('cursor-pointer', 'font-open-sans', 'text-gray-600', 'text-small');

    const MobileLabel = () => (
        <label htmlFor="sortByFilter" className={labelClasses}>
            <Icon className="mr-1" height="22" width="22">
                <YdtSort />
            </Icon>
            Sort
        </label>
    );

    const sortWrapperDesktopClasses = cx(
        'border-1',
        'border-gray-300',
        'border-solid',
        'flex',
        'items-center',
        'pl-2',
        'relative',
        'rounded-medium',
        'sort-wrapper-desktop'
    );

    if (isDesktop)
        return (
            <div className={cx(sortWrapperDesktopClasses, className)}>
                <YodaDropdown
                    automationId="sortDropdown"
                    dataSource={parseSortOptions}
                    defaultValue={selectSortValue()}
                    dropdownLabel="Sort By: "
                    dropdownTheme={styles['desktop-dropdown-theme']}
                    onChange={onChange}
                    theme={styles['desktop-dropdown-wrapper-theme']}
                    tooltipWrapper={styles['desktop-dropdown-wrapper-theme']}
                />
            </div>
        );

    if (isTablet && enableDesktopViewForTablet && isOrientationChange)
        return (
            <div className={cx('sort-wrapper-tablet', className)}>
                <div className={sortWrapperDesktopClasses}>
                    <YodaDropdown
                        automationId="sortDropdown"
                        dataSource={parseSortOptions}
                        defaultValue={selectSortValue()}
                        dropdownLabel="Sort By: "
                        dropdownTheme={styles['desktop-dropdown-theme']}
                        forceDesktop
                        onChange={onChange}
                        theme={styles['tablet-dropdown-wrapper-theme']}
                        tooltipWrapper={styles['tablet-dropdown-wrapper-theme']}
                    />
                </div>
                <div className={styles['sort-wrapper-mobile']}>
                    <MobileLabel />
                    <YodaDropdown
                        automationId="sortDropdown"
                        dataSource={parseSortOptions}
                        defaultValue={selectSortValue()}
                        id="sortByFilter"
                        mobileTheme={styles['mobile-dropdown-theme']}
                        onChange={onChange}
                    />
                </div>
            </div>
        );

    return (
        <div className={cx('sort-wrapper-mobile', className)}>
            <MobileLabel />
            <YodaDropdown
                automationId="sortDropdown"
                dataSource={parseSortOptions}
                defaultValue={selectSortValue()}
                id="sortByFilter"
                mobileTheme={styles['mobile-dropdown-theme']}
                onChange={onChange}
            />
        </div>
    );
};

SortBy.defaultProps = {
    className: '',
};

SortBy.propTypes = {
    className: string,
};

export default SortBy;
